<form class="space-y-3 sm:space-y-4 w-full max-w-full" (submit)="guardar($event)">
  <!-- Nombre -->
  <div>
    <label for="nombre" class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
      Nombre
    </label>
    <input
      [formField]="$any(empleadoForm.nombre_completo)"
      id="nombre"
      type="text"
      placeholder="Nombre del empleado"
      class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm sm:text-sm"
      [class.border-red-500]="
        empleadoForm.nombre_completo().touched() && empleadoForm.nombre_completo().invalid()
      "
    />
    @if (empleadoForm.nombre_completo().touched() && empleadoForm.nombre_completo().invalid()) {
      <div class="text-sm text-red-600 mt-1">
        {{ empleadoForm.nombre_completo().errors() | formErrorMessage }}
      </div>
    }
  </div>

  <!-- Email -->
  <div>
    <label for="email" class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
      Email
    </label>
    <input
      [formField]="$any(empleadoForm.email)"
      id="email"
      type="email"
      placeholder="correo@ejemplo.com"
      class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm sm:text-sm"
      [class.border-red-500]="empleadoForm.email().touched() && empleadoForm.email().invalid()"
    />
    @if (empleadoForm.email().touched() && empleadoForm.email().invalid()) {
      <div class="text-sm text-red-600 mt-1">
        {{ empleadoForm.email().errors() | formErrorMessage }}
      </div>
    }
  </div>

  <!-- Teléfono -->
  <div>
    <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1" for="numero_celular"
      >Número de Celular:</label
    >
    <div class="flex">
      <span class="inline-flex items-center px-3 py-2 text-sm text-gray-500 bg-gray-100 border border-gray-300 border-r-0 rounded-l-lg">
        <i class="bi bi-telephone"></i>
      </span>
      <app-input-mask
        name="num_empleado"
        mask="+51-999-999-999"
        [(value)]="telefono"
        placeholder="+51-999-999-999"
        styleClass="rounded-l-none"
      />
    </div>
  </div>

  <!-- Sucursal -->
  <div>
    <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
      Sucursal
    </label>
    <app-select
      [options]="opcionesSucursal()"
      [formField]="$any(empleadoForm.sucursal_id)"
      placeholder="Todas las sucursales"
      styleClass="w-full"
    />
    <small class="text-gray-400 text-xs mt-1 block"
      >Selecciona una sucursal para restringir acceso, o "Todas" para acceso completo.</small
    >
  </div>

  <!-- Cambiar Contraseña Toggle -->
  <div class="pt-2">
    <button
      type="button"
      class="text-xs sm:text-sm text-blue-600 hover:text-blue-700 font-medium active:scale-95 transition-transform"
      (click)="onTogglePasswordChange()"
    >
      {{ showPasswordChange == true ? '-' : '+' }} Cambiar Contraseña
    </button>
  </div>

  <!-- Contraseña (Condicional) -->
  @if (showPasswordChange) {
    <div class="animate-in slide-in-from-top duration-300">
      <label for="password" class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
        Nueva Contraseña
      </label>
      <app-password
        [formField]="$any(empleadoForm.contra)"
        [toggleMask]="true"
        autocomplete="off"
        promptLabel="Ingrese una contraseña"
        weakLabel="Contraseña muy simple"
        mediumLabel="Complejidad media"
        strongLabel="Contraseña compleja"
        [pattern]="patternPassword"
        styleClass="w-full"
        [invalid]="empleadoForm.contra().touched() && empleadoForm.contra().invalid()"
      />

      @if (empleadoForm.contra().touched() && empleadoForm.contra().invalid()) {
        <div class="text-sm text-red-600 mt-1">
          {{ empleadoForm.contra().errors() | formErrorMessage }}
        </div>
      }
    </div>
  }

  <!-- Permisos -->
  <div class="pt-2">
    <div class="flex items-center mb-3 gap-2 sm:gap-3">
      <label class="block text-xs sm:text-sm font-medium text-gray-700">Permisos</label>
      <app-button
        icon="bi bi-stars"
        variant="primary"
        [rounded]="true"
        (onClick)="limpiarPermisos()"
        [disabled]="!this.empleadoForm().controlValue().permisos.length"
        size="sm"
        appTooltip="Quitar todos los permisos"
        tooltipPosition="top"
      ></app-button>
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
      @for (permiso of grupoPermisoService.permisosAgrupados(); track permiso.categoria) {
        <fieldset
          class="border border-gray-200 rounded-lg p-3 sm:p-4 hover:bg-gray-50 transition-colors"
        >
          <legend class="text-xs sm:text-sm font-semibold text-gray-700 mb-2 px-1">
            {{ grupoPermisoService.getNombreCategoriaAmigable(permiso.categoria) }}
          </legend>
          <div class="flex flex-col gap-2">
            @for (item of permiso.permisos; track $index) {
              <label class="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  [checked]="empleadoForm().controlValue().permisos.includes(item)"
                  (change)="onTogglePermiso(item, $event)"
                  class="w-4 h-4 text-blue-600 rounded focus:ring-2 focus:ring-blue-500"
                />
                <span class="text-xs sm:text-sm text-gray-700">{{
                  grupoPermisoService.getNombrePermisoAmigable(item)
                }}</span>
              </label>
            }
          </div>
        </fieldset>
      }
    </div>
  </div>

  <!-- Botones -->
  <div class="flex flex-col-reverse sm:flex-row gap-2 sm:gap-3 pt-3 sm:pt-4">
    <button
      type="button"
      class="w-full sm:flex-1 px-4 py-2.5 border border-gray-300 rounded-lg text-gray-700 font-medium hover:bg-gray-50 active:scale-95 transition-all text-sm sm:text-base"
      (click)="onCerrar()"
    >
      Cancelar
    </button>
    <button
      type="submit"
      class="w-full sm:flex-1 px-4 py-2.5 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 active:scale-95 transition-all text-sm sm:text-base"
    >
      Guardar
    </button>
  </div>
</form>